/**
 * @generated SignedSource<<7c5f3268a06f68b360e3bcf10133c8a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KPITeamScreen_team$data = {
  readonly KPIS: ReadonlyArray<{
    readonly id: string;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"KPIItemTeam_Routine">;
  }> | null;
  readonly id: string;
  readonly " $fragmentType": "KPITeamScreen_team";
};
export type KPITeamScreen_team$key = {
  readonly " $data"?: KPITeamScreen_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPITeamScreen_team">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPITeamScreen_team",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "KPIS",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "KPI"
        }
      ],
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routines",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "KPIItemTeam_Routine"
        }
      ],
      "storageKey": "routines(type:\"KPI\")"
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "6da278ed167bab3cebc446ada5f6261f";

export default node;
